/**
 * 传感器api
 * 注：因为属于重构  所以以前有的接口就拿之前的 新添加的接口从这里获取
 * date:2022 03 18

 */
import httpRequest from '@/utils/request.js'
import qs from 'qs'

// 传感器列表分页信息
export const sensorList = (params = {}, way) =>
  httpRequest.httpGet({
    url: `/service/sensor/lst/${way}`,
    params: {
      ...params
    }
  })
/** 获取传感器参数配置信息 */
export const sensorGetDetailConfig = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/sensor/getDetailConfig/' + way,
    params: {
      ...params
    }
  })

/** 更新传感器网络参数 */
export const sensorUpdateNetConfig = (data, loadingOptions) =>
  httpRequest.httpPost('/service/sensor/updateNetConfig', data, loadingOptions)

/** 更新传感器上报规则 */
export const sensorUpdateAppConfig = (data, loadingOptions) =>
  httpRequest.httpPost('/service/sensor/updateAppConfig', data, loadingOptions)

/** 获取传感器配置日志列表接口 */
export const sensorGetConfiglogList = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/sensor/getConfiglogList',
    params: {
      ...params
    }
  })
/** 更新传感器状态 */
export const sensorUpdateStatus = (data, loadingOptions) =>
  httpRequest.httpPost('/service/sensor/updateStatus', data, loadingOptions)
/** 添加传感器接口 */
export const sensorAddSensor = (data, loadingOptions) =>
  httpRequest.httpPost('/service/sensor/addSensor', data, loadingOptions)

// 未确认传感器的详情
export const sensorGetSensorDetailInfo = id =>
  httpRequest.httpGet({
    url: '/service/sensor/getSensorDetailInfo/' + id
  })
// 未确认传感器的详情
export const sensorDeleteSensor = (data, loadingOptions) =>
  httpRequest.httpdelete('/service/sensor/deleteSensor', data, loadingOptions)
/** 修改基础信息 */
export const sensorUpdateSensor = (data, loadingOptions) =>
  httpRequest.httpPost('/service/sensor/updateSensor', data, loadingOptions)
/** 通过ID获取载体信息接口 */
export const CarrierInfo = (type, id) =>
  httpRequest.httpGet({
    url: `/service/carrier/detail/${type}/${id}`
  })

/**
 * 通过tagId查询传感器详情
 * @param tagId
 * @returns {Promise | Promise<unknown>}
 */
export const getSensorDetail = tagId =>
  httpRequest.httpGet({
    url: `/service/sensor/detail/${tagId}`
  })

/**
 * 更新声光报警配置
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const updateSoundLightAlarmConfig = data =>
  httpRequest.httpPost('/service/sensor/updateAlarmConfig', data)

/**
 * 更新gps定位配置
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const updateGPSConfig = data =>
  httpRequest.httpPost('/service/sensor/updateGPSConfig', data)

/**
 * 更新传感器的客户
 */
export const updateCustomer = data =>
  httpRequest.httpPost('/service/sensor/update/customer', qs.stringify(data))

/**
 * 保存设备校准(单个)
 */
export const saveCalibration = (data, type = 0) =>
  httpRequest.httpPost(`/service/calibration/${type}/save`, data)
/**
 * 保存设备校准(批量)
 */
export const saveCalibrationBatch = (data, type = 0) =>
  httpRequest.httpPost(`/service/calibration/${type}/save/batch`, data)
/**
 * 下载校准模板
 */
export const downloadCalibrationTemplate = () =>
  httpRequest.download('/service/calibration/sensor/zh_CN/generaUploadTemplateFile')
/**
 * 校准文件导入
 */
export const saveCalibrationExport = (data, type = 0) =>
httpRequest.httpPost(`/service/calibration/${type}/export`, data)
/**
 * 通过id查询设备校准详情
 * @param id
 */
export const getCalibrationInfo = (id, type = 0) =>
 httpRequest.httpGet({
   url: `/service/calibration/get/${type}/${id}`
 })
/**获取设备校准过期列表 */
export const getCalibrationExpiredList = (device_catalog) =>
  httpRequest.httpGet({
      url: `/service/calibration/${device_catalog}/expired/list`,
  });
/**获取气体分页列表 */
export const gasList = (params = {}, way) =>
  httpRequest.httpGet({
    url: `/service/gas/page/${way}`,
    params: {
      ...params
    }
  })
/** 添加气体传感器 */
export const AddGas = (data, loadingOptions) =>
httpRequest.httpPost('/service/gas/add', data, loadingOptions)
/** 删除气体传感器 
 * type: 0-标记删除，1-物理删除
*/
export const deleteGas = (type, gasId) =>
  httpRequest.httpdelete(`/service/gas/delete/${type}/${gasId}`)
/** 批量删除气体传感器 
 * type: 0-标记删除，1-物理删除
*/
export const deleteGasBatch = (type, gasIds) =>
httpRequest.httpPost(`/service/gas/delete/batch/${type}`, gasIds)
/**获取气体分页列表
 * type: use- 使用，unused-停用
 */
export const gasStatusUse = (type, gasIds) =>
  httpRequest.httpPost(`/service/gas/status/${type}`, gasIds)

// 编辑气体
export const gasDetail = id =>
  httpRequest.httpGet({
    url: '/service/gas/edit/' + id
  })
/** 更新气体传感器 */
export const updateGas = (data) =>
httpRequest.httpPost('/service/gas/upt', data)
/**
 * 更新气体传感器的客户
 */
 export const updateGasCustomer = (sceneId, gasIds) =>
 httpRequest.httpPost( `/service/gas/update/customer/${sceneId}`, gasIds)
 
/** 更新气体上报规则 */
export const gasUpdateAppConfig = (data) =>
httpRequest.httpPut('/service/gas/updateAppConfig', data)

// 气体的详情
export const gasDetailInfo = id =>
  httpRequest.httpGet({
    url: '/service/gas/detail/' + id
  })
/** 获取气体参数配置信息 */
export const gasGetDetailConfig = id =>
  httpRequest.httpGet({
    url: `/service/gas/getAppConfig/${id}`
  })


/**获取门磁分页列表 */
export const magnetismList = (params = {}, way) =>
  httpRequest.httpGet({
    url: `/service/magnetism/page/${way}`,
    params: {
      ...params
    }
  })
/** 添加门磁传感器 */
export const addMagnetism = (data, loadingOptions) =>
httpRequest.httpPost('/service/magnetism/add', data, loadingOptions)
/** 删除门磁传感器 
 * type: 0-标记删除，1-物理删除
*/
export const deleteMagnetism = (type, magnetismId) =>
  httpRequest.httpdelete(`/service/magnetism/delete/${type}/${magnetismId}`)
/** 批量删除门磁传感器 
 * type: 0-标记删除，1-物理删除
*/
export const deleteMagnetismBatch = (type, magnetismIds) =>
httpRequest.httpPost(`/service/magnetism/delete/batch/${type}`, magnetismIds)
/**获取门磁分页列表
 * type: use- 使用，unused-停用
 */
export const magnetismStatusUse = (type, magnetismIds) =>
  httpRequest.httpPost(`/service/magnetism/status/${type}`, magnetismIds)

// 编辑门磁
export const magnetismDetail = id =>
  httpRequest.httpGet({
    url: '/service/magnetism/edit/' + id
  })
/** 更新门磁传感器 */
export const updateMagnetism = (data) =>
httpRequest.httpPost('/service/magnetism/upt', data)
/**
 * 更新门磁传感器的客户
 */
 export const updateMagnetismCustomer = (sceneId, magnetismIds) =>
 httpRequest.httpPost( `/service/magnetism/update/customer/${sceneId}`, magnetismIds)
 
/** 更新门磁上报规则 */
export const magnetismUpdateAppConfig = (data) =>
httpRequest.httpPut('/service/magnetism/updateAppConfig', data)

// 门磁的详情
export const magnetismDetailInfo = id =>
  httpRequest.httpGet({
    url: '/service/magnetism/detail/' + id
  })
/** 获取门磁参数配置信息 */
export const magnetismGetDetailConfig = id =>
  httpRequest.httpGet({
    url: `/service/magnetism/getAppConfig/${id}`
  })